
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,
  TableBody,
  TableCell,
   TableContainer,
                Paper,
  Checkbox, FormControlLabel, FormHelperText, Divider,
  CircularProgress,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import { Card, Box, Typography, Avatar, Chip, Collapse, InputAdornment, IconButton, Tooltip, Menu } from "@material-ui/core";
import CalenderAssignmentService from "./Locality/Service/calenderAssignmentService";
import AddClassService from "./Locality/Service/addClassService";
import StudentService from "./Locality/Service/studentService";
import SectionService from "./Locality/Service/sectionService";
import IconMasterService from "./Locality/Service/iconMasterService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import EventIcon from '@material-ui/icons/Event';
import ImageIcon from '@material-ui/icons/Image';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DescriptionIcon from '@material-ui/icons/Description';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import VideocamIcon from '@material-ui/icons/Videocam';
import { makeStyles } from '@material-ui/core/styles';

const getDocumentFileName = (url) => {
  try {
    const path = (url || '').split('/').pop() || url;
    return (path || '').split('?')[0] || 'school-calendar.docx';
  } catch {
    return 'school-calendar.docx';
  }
};

const fileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

const MAX_MEDIA_AT_A_TIME = 10;
const MAX_VIDEO_AUDIO_SIZE_MB = 50;
const MAX_VIDEO_AUDIO_BYTES = MAX_VIDEO_AUDIO_SIZE_MB * 1024 * 1024;

const formatFileSizeMb = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const getOversizedVideoAudioFiles = (files) =>
  (files || []).filter((file) => {
    const type = getMediaTypeFromFile(file);
    return (type === "video" || type === "audio") && file.size > MAX_VIDEO_AUDIO_BYTES;
  });

const filterValidMediaFiles = (files) => {
  const oversized = getOversizedVideoAudioFiles(files);
  if (!oversized.length) return files;
  const names = oversized.map((f) => `${f.name} (${formatFileSizeMb(f.size)})`).join("\n");
  alert(
    `Video and audio files must be ${MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.\n\nToo large:\n${names}`
  );
  return files.filter((f) => !oversized.includes(f));
};

const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;
const AUDIO_EXT = /\.(mp3|wav|ogg|m4a|aac|flac|mpeg)(\?|$)/i;

const getMediaTypeFromFile = (file) => {
  if (!file) return 'image';
  const mime = file.type || '';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime.startsWith('image/')) return 'image';
  const name = (file.name || '').toLowerCase();
  if (VIDEO_EXT.test(name)) return 'video';
  if (AUDIO_EXT.test(name)) return 'audio';
  return 'image';
};

const getMediaTypeFromUrl = (url) => {
  if (!url || typeof url !== 'string') return 'image';
  const lower = url.split('?')[0].toLowerCase();
  if (VIDEO_EXT.test(lower)) return 'video';
  if (AUDIO_EXT.test(lower)) return 'audio';
  return 'image';
};

const groupMediaByType = (items, getType) => {
  const groups = { image: [], video: [], audio: [] };
  items.forEach((item, index) => {
    const type = getType(item);
    groups[type].push({ item, index });
  });
  return groups;
};

const mergeSelectedFiles = (existing, incoming) => {
  const keys = new Set(existing.map(fileKey));
  return [...existing, ...incoming.filter((f) => !keys.has(fileKey(f)))];
};

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  primaryBtn: {
    backgroundColor: '#1769d6',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 18px',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 14px',
    borderRadius: 8,
    backgroundColor: '#f4f6fa',
    border: '1px solid #e6eaf0',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    fontSize: '0.9rem',
  },
  countBadge: {
    backgroundColor: '#1769d6',
    color: '#fff',
    borderRadius: 10,
    fontSize: '0.72rem',
    fontWeight: 700,
    minWidth: 18,
    height: 18,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 5px',
  },
  fieldLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #e6eaf0',
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid #eef1f5',
  },
  iconBtnOutlined: {
    border: '1px solid #e6eaf0',
    borderRadius: 8,
    padding: 7,
  },
  headCell: {
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    whiteSpace: 'nowrap',
  },
  classChip: {
    backgroundColor: '#eef4ff',
    color: '#1769d6',
    fontWeight: 600,
    height: 24,
  },
  sectionChip: {
    backgroundColor: '#f3efff',
    color: '#7c4dff',
    fontWeight: 600,
    height: 24,
  },
  studentAvatar: {
    width: 30,
    height: 30,
    fontSize: '0.8rem',
    backgroundColor: '#1769d6',
  },
  imagesBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    fontSize: '0.78rem',
  },
  noteExpandRow: {
    backgroundColor: '#f8fafc',
    '& td': {
      borderBottom: '1px solid #e6eaf0',
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
  },
  noteExpandBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: 10,
    border: '1px solid #e6eaf0',
    backgroundColor: '#fff',
  },
  iconAction: {
    color: '#1769d6',
    padding: 6,
  },
  actionsCell: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 2,
    flexWrap: 'nowrap',
  },
  eventDetailsDialogPaper: {
    borderRadius: 12,
    maxWidth: 560,
    width: '100%',
  },
  eventDetailBlock: {
    marginBottom: theme.spacing(2),
  },
  eventDetailLabel: {
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#9aa6b6',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: 6,
  },
  dialogPaper: {
    borderRadius: 14,
    width: 520,
    maxWidth: '95vw',
  },
  dialogTitleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2.5),
    borderBottom: '1px solid #eef1f5',
  },
  dialogTitleText: {
    fontWeight: 700,
    fontSize: '1.15rem',
    color: '#0f2d4d',
  },
  dialogBody: {
    padding: theme.spacing(2.5),
  },
  sectionLabel: {
    fontWeight: 700,
    color: '#46566b',
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(1.25),
  },
  formSection: {
    marginBottom: theme.spacing(2.5),
  },
  uploadBox: {
    border: '1px dashed #c5d3e6',
    borderRadius: 10,
    backgroundColor: '#f8fafc',
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  uploadBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#1769d6',
    color: '#fff',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  previewThumb: {
    width: 84,
    height: 84,
    objectFit: 'cover',
    borderRadius: 8,
    border: '1px solid #e6eaf0',
  },
  removeThumbBtn: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    padding: 2,
    minWidth: 'auto',
  },
  pendingPanel: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: 10,
    border: '1px solid #e6eaf0',
    backgroundColor: '#fff',
  },
  pendingFileName: {
    fontSize: '0.72rem',
    color: '#6b7280',
    marginTop: 4,
    maxWidth: 84,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  mediaTypeLabel: {
    fontSize: '0.75rem',
    fontWeight: 700,
    color: '#46566b',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  mediaPlayTile: {
    width: 84,
    height: 84,
    borderRadius: 8,
    border: '1px solid #e6eaf0',
    backgroundColor: '#0f2d4d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative',
    '&:hover': { backgroundColor: '#1769d6' },
  },
  mediaAudioTile: {
    width: 84,
    height: 84,
    borderRadius: 8,
    border: '1px solid #e6eaf0',
    backgroundColor: '#eef4ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': { backgroundColor: '#dbeafe' },
  },
  mediaPlayerDialog: {
    borderRadius: 12,
    maxWidth: 900,
    width: '100%',
    backgroundColor: '#000',
  },
  mediaPlayerVideo: {
    width: '100%',
    maxHeight: '70vh',
    outline: 'none',
  },
  studentsDialogPaper: {
    borderRadius: 12,
    maxWidth: 400,
    width: '100%',
  },
  studentsList: {
    maxHeight: 320,
    overflowY: 'auto',
    padding: 0,
  },
  studentCountChip: {
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 600,
    height: 24,
  },
  dialogFooter: {
    padding: theme.spacing(1.5, 2.5),
    borderTop: '1px solid #eef1f5',
  },
  cancelBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
  },
  addBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#1769d6',
    color: '#fff',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
    '&.Mui-disabled': { backgroundColor: '#cbd5e1', color: '#fff' },
  },
}));
export default function CalenderAssignment() {
  const history = useHistory();

  const columnConfig = [
    { id: 'student', label: 'Student' },
    { id: 'eventName', label: 'Event Name' },
    { id: 'class', label: 'Class' },
    { id: 'section', label: 'Section' },
    { id: 'details', label: 'View' },
    { id: 'date', label: 'Date' },
    { id: 'images', label: 'Media' },
  ];
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [viewEventDetails, setViewEventDetails] = useState({ open: false, row: null });
  const [visibleCols, setVisibleCols] = useState({
    student: true,
    eventName: true,
    class: true,
    section: true,
    details: true,
    date: true,
    images: true,
  });

  const eventHasImages = (row) =>
    Array.isArray(row?.imageURL) && row.imageURL.filter(Boolean).length > 0;
  const [images, setImages] = useState([]);
  const [imageslist, setImagesList] = useState([]);
  const fileInputRef = useRef(null);
  const [mediaPlayer, setMediaPlayer] = useState({ open: false, url: '', type: 'image', title: '' });
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0, fileName: '' });
  const [viewStudents, setViewStudents] = useState({
    open: false,
    title: '',
    loading: false,
    isAll: false,
    items: [],
  });
  const [message, setMessage] = useState("");
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [listClassId, setListClassId] = useState("");
  const [listSectionId, setListSectionId] = useState("");
  const [listSectionList, setListSectionList] = useState([]);
  const [calenderAssignmentList, setCalenderAssignmentList] = useState([]);
  const [activeIcons, setActiveIcons] = useState([]);
  const [dueDate, setFormDueDate] = useState("");
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [addEventLoading, setAddEventLoading] = useState(false);
  const [schoolCalenderDocs, setSchoolCalenderDocs] = useState([]);
  const [schoolCalenderClassId, setSchoolCalenderClassId] = useState('');
  const [schoolCalenderUploading, setSchoolCalenderUploading] = useState(false);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(100);
  const current = new Date();
  var [classId, setClassId] = useState("");
  const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
  var [dateValue, setDateValue] = useState(date);
  const [eventId, setEventId] = useState('');
  const [year, month, day] = date.split("-");
  const [calenderAssignment, setCalenderAssignment] = useState({
    eventName: '',
    imageURL: [],
    observation: '',
    video: '',
    studentId: [],
    date: '',
    isEventForAllStudent: false,
    iconId: '',
    sectionId: '',
  });

 
  const validationSchema = Yup.object().shape({
    eventName: Yup.string().required('event Name is required'),
    studentId: Yup.array(),
    video: Yup.string(),
    date: Yup.string().required('Event Date is required'),
    observation: Yup.string(),
    classId: Yup.string(),
    sectionId: Yup.string(),
    imageURL: Yup.array(),
    isEventForAllStudent: Yup.boolean(),
    iconId: Yup.string(),
  });
 
  const verifyeetnt = () => {
    console.log(formik)
  }
  const handleOpen = (status) => {
    if (status) {
      const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
      const initial = {
        eventName: '',
        imageURL: [],
        observation: '',
        video: '',
        studentId: [],
        date: '',
        isEventForAllStudent: false,
        iconId: '',
        sectionId: '',
        classId: userDetails.role === "TEACHER" ? (userDetails.classId || '') : '',
      };
      if (userDetails.role === "TEACHER" && userDetails.classId) {
        getSectionListByClass(userDetails.classId);
        getStudentList(userDetails.classId, userDetails.sectionId || undefined);
        initial.sectionId = userDetails.sectionId || '';
      }
      setCalenderAssignment(initial);
    }
    setAddEventLoading(false);
    setOpen(true);
  };
  const handleChangePage = (event, newpage) => {
    setpg(newpage);
  }
  const handleChangeRowsPerPage = (event) => {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  useEffect(() => {
    getAddClassList();
    getActiveIcons();
    fetchSchoolCalender();
    return () => {
      setCalenderAssignmentList([]);
      setStudentList([]);
    }
  }, []);

  useEffect(() => {
    getCalenderAssignmentList();
  }, [listClassId, listSectionId]);

  useEffect(() => {
    const refreshList = () => getCalenderAssignmentList();
    window.addEventListener("calendarEventUpdated", refreshList);
    return () => window.removeEventListener("calendarEventUpdated", refreshList);
  }, [listClassId, listSectionId]);

  const getActiveIcons = () => {
    const body = { status: 'active' };
    IconMasterService.findIconMasterList(body)
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setActiveIcons(list.filter((icon) => icon.imageUrl));
      })
      .catch((err) => {
        console.error("Error fetching active icons:", err);
      });
  };
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDueDate(value);
  };

  const pendingPreviews = useMemo(
    () =>
      images.map((file) => ({
        file,
        key: fileKey(file),
        url: URL.createObjectURL(file),
      })),
    [images],
  );

  useEffect(() => {
    return () => {
      pendingPreviews.forEach((preview) => URL.revokeObjectURL(preview.url));
    };
  }, [pendingPreviews]);

  const handleFileChange = (e) => {
    const picked = filterValidMediaFiles(Array.from(e.target.files || []));
    if (!picked.length) {
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    if (picked.length > MAX_MEDIA_AT_A_TIME) {
      alert(`You can select at most ${MAX_MEDIA_AT_A_TIME} files at a time.`);
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    setImages((prev) => {
      const merged = mergeSelectedFiles(prev, picked);
      if (merged.length > MAX_MEDIA_AT_A_TIME) {
        alert(
          `You can upload at most ${MAX_MEDIA_AT_A_TIME} files at a time. Remove some files or upload the current selection first.`
        );
        return prev;
      }
      return merged;
    });
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const removePendingImageAt = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };
  const handleUpload = async (e) => {
    e.preventDefault();

    if (!images || images.length === 0) {
      setMessage("Please select files first.");
      return;
    }

    if (images.length > MAX_MEDIA_AT_A_TIME) {
      alert(`You can upload at most ${MAX_MEDIA_AT_A_TIME} files at a time.`);
      return;
    }

    const oversized = getOversizedVideoAudioFiles(images);
    if (oversized.length) {
      const names = oversized.map((f) => `${f.name} (${formatFileSizeMb(f.size)})`).join("\n");
      alert(
        `Video and audio files must be ${MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.\n\nToo large:\n${names}`
      );
      return;
    }

    setUploading(true);
    setUploadProgress({ current: 0, total: images.length, fileName: '' });

    try {
      for (let i = 0; i < images.length; i += 1) {
        const file = images[i];
        setUploadProgress({ current: i, total: images.length, fileName: file.name });
        const formData = new FormData();
        formData.append("image", file);
        formData.append("imageName", file.name);
        // eslint-disable-next-line no-await-in-loop
        const res = await CalenderAssignmentService.uploadImage(formData);
        const url = res?.url || res?.imageName;
        if (!url) throw new Error("Upload succeeded but no file URL returned.");
        setImagesList((prev) => {
          const next = [...(Array.isArray(prev) ? prev : []), url];
          formik.setFieldValue("imageURL", next);
          return next;
        });
        setUploadProgress({ current: i + 1, total: images.length, fileName: file.name });
      }
      alert("Files uploaded successfully");
      setImages([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
    } catch (error) {
      console.error("Error uploading files:", error);
      alert(error?.message || "An error occurred while uploading the files.");
    } finally {
      setUploading(false);
      setUploadProgress({ current: 0, total: 0, fileName: '' });
    }

  };

  // Function to format date to D/M/Y format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        // If dateString is already in YYYY-MM-DD format, parse it manually
        const parts = dateString.split("-");
        if (parts.length === 3) {
          const day = parts[2];
          const month = parts[1];
          const year = parts[0];
          return `${day}/${month}/${year}`;
        }
        return dateString;
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const fetchSchoolCalender = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!userDetails.schooleId) return;

    CalenderAssignmentService.getCalenderDocument({ schooleId: userDetails.schooleId })
      .then((res) => {
        const list = Array.isArray(res) ? res.filter((row) => row.schoolCalenderDocument) : [];
        setSchoolCalenderDocs(list);
      })
      .catch(() => {
        setSchoolCalenderDocs([]);
      });
  };

  const getCalenderAssignmentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const params = {};
    if (userDetails.schooleId) params.schooleId = userDetails.schooleId;
    if (listClassId) params.classId = listClassId;
    if (listSectionId) params.sectionId = listSectionId;
    CalenderAssignmentService.getAllCalenderAssignment(params)
      .then((res) => {
        setCalenderAssignmentList(res);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  const saveSchoolCalenderDocument = async (documentUrl) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const payload = {
      schoolCalenderDocument: documentUrl,
      schooleId: userDetails.schooleId,
      status: true,
    };
    if (schoolCalenderClassId) {
      payload.classId = schoolCalenderClassId;
    }

    await CalenderAssignmentService.addCalenderDocument(payload);

    fetchSchoolCalender();
    return true;
  };

  const handleSchoolCalenderUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const isValidWord =
      /\.(docx?|DOCX?)$/.test(file.name) ||
      file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (!isValidWord) {
      alert('Please upload a Word document (.doc or .docx).');
      if (e.target) e.target.value = '';
      return;
    }

    setSchoolCalenderUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageName', file.name);
      const res = await CalenderAssignmentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) throw new Error('Upload succeeded but no document URL returned.');

      const saved = await saveSchoolCalenderDocument(url);
      if (saved) {
        alert('School calendar uploaded successfully.');
      }
    } catch (error) {
      console.error('School calendar upload failed:', error);
      alert(error?.message || 'Failed to upload school calendar.');
    } finally {
      setSchoolCalenderUploading(false);
      if (e.target) e.target.value = '';
    }
  };

  const handleSchoolCalenderRemove = async (doc) => {
    if (!doc?._id) return;
    const confirmDelete = window.confirm('Remove this school calendar document?');
    if (!confirmDelete) return;

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    try {
      await CalenderAssignmentService.deleteCalenderDocument(doc._id, { schooleId: userDetails.schooleId });
      fetchSchoolCalender();
      alert('School calendar document removed.');
    } catch (error) {
      alert(error?.response?.data?.message || 'Failed to remove school calendar document.');
    }
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
    setImages([]);
    setImagesList([]);
    if (fileInputRef.current) fileInputRef.current.value = '';
    // Reset form when closing
    const resetData = {
      eventName: '',
      imageURL: [],
      observation: '',
      video: '',
      studentId: [],
      date: '',
      isEventForAllStudent: false,
      iconId: '',
      sectionId: '',
    };
    setCalenderAssignment(resetData);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const getSectionListByClass = (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!classId) {
      setSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      let list = Array.isArray(res) ? res : [];
      setSectionList(list);
    }).catch(() => setSectionList([]));
  };

  const getListSectionListByClass = (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!classId) {
      setListSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      setListSectionList(Array.isArray(res) ? res : []);
    }).catch(() => setListSectionList([]));
  };

  const onListClassChange = (e) => {
    const id = e.target.value;
    setListClassId(id);
    setListSectionId("");
    setpg(0);
    getListSectionListByClass(id);
  };

  const onListSectionChange = (e) => {
    setListSectionId(e.target.value);
    setpg(0);
  };

  const getAddClassList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
      setAddClassList(res);
    }).catch((err) => {
      // setError(err.message);
    });
  }
 
  const editCalenderAssignment = (calenderassignment, status) => {
    const obj = JSON.parse(JSON.stringify(calenderassignment));
    obj.classId = calenderassignment.classId
      ? (calenderassignment.classId._id || calenderassignment.classId)
      : '';
    obj.sectionId = calenderassignment.sectionId
      ? (calenderassignment.sectionId._id || calenderassignment.sectionId)
      : '';
    obj.studentId = Array.isArray(calenderassignment.studentId)
    ? calenderassignment.studentId.map(student => student._id)
    : calenderassignment.studentId
    
    // Handle iconId - it can be an object (populated) or a string ID
    if (calenderassignment.iconId) {
      if (typeof calenderassignment.iconId === 'object' && calenderassignment.iconId._id) {
        obj.iconId = calenderassignment.iconId._id;
      } else if (typeof calenderassignment.iconId === 'string') {
        obj.iconId = calenderassignment.iconId;
      } else {
        obj.iconId = '';
      }
    } else {
      obj.iconId = '';
    }

    // Set existing images if any
    if (calenderassignment.imageURL && Array.isArray(calenderassignment.imageURL) && calenderassignment.imageURL.length > 0) {
      setImagesList(calenderassignment.imageURL);
    } else {
      setImagesList([]);
    }

    getSectionListByClass(obj.classId);
    getStudentList(obj.classId, obj.sectionId || undefined);
    getAddClassList();

    if (status) {
      delete obj._id;
    }
    setCalenderAssignment(obj);
    handleOpen();
  }
  const removeImage = (index, imageURL) => {
    const urlToRemove = imageURL || (Array.isArray(imageslist) ? imageslist[index] : undefined);
    const updatedList = (Array.isArray(imageslist) ? imageslist : []).filter((_, i) => i !== index);
    setImagesList(updatedList);
    formik.setFieldValue("imageURL", updatedList);

    if (!urlToRemove) return;
    CalenderAssignmentService.deleteAzureImage({ imageURL: urlToRemove }).catch(() => {
      // ignore delete failures; UI stays responsive
    });
  };
  const deleteCalenderAssignment = (calenderassignment) => {
    if (calenderassignment) {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this Event?"
      );
      
      if (!confirmDelete) {
        return;
      }

      CalenderAssignmentService.deleteCalenderAssignment(calenderassignment).then((res) => {
        getCalenderAssignmentList();
        // Dispatch custom event to notify Calendar.js to refresh
        window.dispatchEvent(new CustomEvent('calendarEventDeleted', { 
          detail: { eventId: calenderassignment._id } 
        }));
        alert("Event deleted successfully!");
      }).catch((err) => {
        alert(err.response?.data?.message || "Error deleting event");
      });
    }
  }


  const getStudentList = (classIdValue, sectionIdValue) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    if (!classIdValue) {
      setStudentList([]);
      return;
    }
    const getSpeList = { classId: classIdValue };
    if (sectionIdValue) getSpeList.sectionId = sectionIdValue;
    StudentService.getAllStudentById(userDetails.schooleId, getSpeList).then((res) => {
      const studentDetails = (res || []).map((r) => ({
        _id: r._id,
        studentName: `${r.firstName || ''} ${r.lastName || ''}`.trim(),
        status: true,
      }));
      setStudentList(studentDetails);
    }).catch(() => setStudentList([]));
  }

  const formik = useFormik({
    initialValues: calenderAssignment,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
        alert('Please select at least one student.');
        return;
      }

      if (values.isEventForAllStudent) {
        if (!values.classId) {
          alert('Please select a class first.');
          return;
        }
        const effectiveSectionId = values.sectionId || null;
        if (studentList.length === 0) {
          alert(
            effectiveSectionId
              ? 'No students found in the selected section. Please add students to this section or choose a different section.'
              : 'No students found in the selected class. Please add students to this class or choose a different class.'
          );
          return;
        }
      }

      setAddEventLoading(true);
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      values.schooleId = userDetails.schooleId;
      values.studentId = values.studentId ? values.studentId : null;
      values.iconId = values.iconId || null;
      values.sectionId = values.sectionId || null;
      values.imageURL = imageslist;
      if (calenderAssignment._id) {

        CalenderAssignmentService.upadeCalenderAssignment(values).then((res) => {

          handleClose();
          getCalenderAssignmentList();
          resetForm()
          setImagesList([])
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventUpdated', { 
            detail: { eventId: calenderAssignment._id } 
          }));
          alert(" Event Updated Successfully.");
        }).catch((err) => {
          alert(err.response?.data?.message || "Error updating event");
        }).finally(() => setAddEventLoading(false));
      }
      else {
        CalenderAssignmentService.creteCalenderAssignment(values).then((res) => {
          getCalenderAssignmentList();
          resetForm();
          handleClose();
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventAdded', { 
            detail: { event: res } 
          }));
          alert(" Event Added Successfully.");
          setImagesList([])
        })
          .catch((err) => {
            alert(err.response?.data?.message || "Error adding event");
          })
          .finally(() => setAddEventLoading(false));
      }

    },
  });

  const test = () => {
    console.log(formik)
  };
  const handleCheck = (event, item) => {
    // event.sounds.SPL
    event.sounds[item] = !event.sounds[item];
    // obj['a'] = true;

    StudentService.upadeStudent(event).then((res) => {
      getStudentList();

    })
      .catch((err) => {
        alert(err.response.data.message)
      })

  };
  // const imageArtist = (eventdetails) => {
  //   getEventImageList(eventdetails.id);
  //   setEventId(eventdetails.id)

  // }
  const getCalenderAssignmentImageList = (eventId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    // CommonService.postRequest(IMAGES.GET+"/getlist", {artiesId:eventId}).then((res) => {
    //     setEventImageList(res);
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue, "eventId": userDetails.calenderAssignmentId
    }
    CalenderAssignmentService.creteImages(keys).then((res) => {
      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

    });
  }
  const onSubmit = data => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue
    }
    CalenderAssignmentService.creteCalenderAssignment(keys).then((res) => {

      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

      alert(err.response.data.message);
    });
  };
  const activeFilterCount = (listClassId ? 1 : 0) + (listSectionId ? 1 : 0);

  const handleResetFilters = () => {
    setListClassId("");
    setListSectionId("");
    setListSectionList([]);
    setpg(0);
  };

  const studentNamesText = (row) => {
    if (row.isEventForAllStudent) return "All Students";
    return (Array.isArray(row.studentId) ? row.studentId : [])
      .map((s) => `${s.firstName || ''} ${s.lastName || ''}`.trim())
      .join(", ");
  };

  const formatStudentName = (s) => {
    if (!s) return '';
    if (typeof s === 'string') return s;
    return `${s.firstName || ''} ${s.lastName || ''}`.trim() || s.studentName || '';
  };

  const getStudentCountLabel = (row) => {
    if (row.isEventForAllStudent) return 'All Students';
    const count = Array.isArray(row.studentId) ? row.studentId.length : 0;
    if (count === 0) return '0 students';
    return count === 1 ? '1 student' : `${count} students`;
  };

  const closeViewStudents = () => {
    setViewStudents({ open: false, title: '', loading: false, isAll: false, items: [] });
  };

  const openViewEventDetails = (row) => {
    setViewEventDetails({ open: true, row });
  };

  const closeViewEventDetails = () => {
    setViewEventDetails({ open: false, row: null });
  };

  const getRowEventIcon = (row) => {
    if (!row?.iconId) return null;
    if (typeof row.iconId === 'object' && (row.iconId.imageUrl || row.iconId.iconName)) {
      return row.iconId;
    }
    return activeIcons.find((icon) => icon._id === row.iconId) || null;
  };

  const openViewStudents = async (row) => {
    const userDetails = JSON.parse(localStorage.getItem('userDetail')) || {};
    const schooleId = userDetails.schooleId?._id || userDetails.schooleId;
    const classId = row.classId?._id || row.classId;
    const sectionId = row.sectionId?._id || row.sectionId;

    setViewStudents({
      open: true,
      title: row.eventName || 'Students',
      loading: true,
      isAll: !!row.isEventForAllStudent,
      items: [],
    });

    try {
      let items = [];
      if (row.isEventForAllStudent) {
        if (classId && schooleId) {
          const body = { classId };
          if (sectionId) body.sectionId = sectionId;
          const res = await StudentService.getAllStudentById(schooleId, body);
          items = (Array.isArray(res) ? res : []).map((s) => ({
            _id: s._id,
            name: formatStudentName(s) || '—',
          }));
        }
      } else {
        const raw = Array.isArray(row.studentId) ? row.studentId : [];
        items = raw.map((s, idx) => ({
          _id: typeof s === 'object' && s?._id ? s._id : `student-${idx}`,
          name: formatStudentName(s) || '—',
        }));
      }
      setViewStudents((prev) => ({ ...prev, loading: false, items }));
    } catch (err) {
      console.error(err);
      setViewStudents((prev) => ({ ...prev, loading: false, items: [] }));
      alert(err?.response?.data?.message || 'Could not load students');
    }
  };

  const filteredList = calenderAssignmentList.filter((row) => {
    if (row.isSchoolCalender) return false;
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return (
      (row.eventName || '').toLowerCase().includes(term) ||
      studentNamesText(row).toLowerCase().includes(term) ||
      (row.classId?.className || '').toLowerCase().includes(term)
    );
  });

  const visibleColCount = Object.values(visibleCols).filter(Boolean).length + 1;

  const openMediaPlayer = (url, type, title = '') => {
    setMediaPlayer({ open: true, url, type, title });
  };

  const renderReadOnlyMediaTile = (url, idx, title = '') => {
    const mediaType = getMediaTypeFromUrl(url);

    if (mediaType === 'video') {
      return (
        <Box
          key={`${url}-${idx}`}
          className={classes.mediaPlayTile}
          onClick={() => openMediaPlayer(url, 'video', title)}
          role="button"
          tabIndex={0}
          aria-label="Play video"
        >
          <PlayArrowIcon style={{ color: '#fff', fontSize: 36 }} />
        </Box>
      );
    }
    if (mediaType === 'audio') {
      return (
        <Box
          key={`${url}-${idx}`}
          className={classes.mediaAudioTile}
          onClick={() => openMediaPlayer(url, 'audio', title)}
          role="button"
          tabIndex={0}
          aria-label="Play audio"
        >
          <AudiotrackIcon style={{ color: '#1769d6', fontSize: 32 }} />
        </Box>
      );
    }
    return (
      <img
        key={`${url}-${idx}`}
        src={url}
        alt={`Media ${idx + 1}`}
        className={classes.previewThumb}
        onClick={() => openMediaPlayer(url, 'image', title)}
        style={{ cursor: 'pointer' }}
      />
    );
  };

  const renderEventDetailsMedia = (row) => {
    const urls = Array.isArray(row?.imageURL) ? row.imageURL.filter(Boolean) : [];
    if (!urls.length) {
      return (
        <Typography variant="body2" color="textSecondary">
          No photos, videos, or audio attached.
        </Typography>
      );
    }

    const grouped = groupMediaByType(urls, getMediaTypeFromUrl);
    const sections = [
      { key: 'image', label: 'Photos', items: grouped.image },
      { key: 'video', label: 'Videos', items: grouped.video },
      { key: 'audio', label: 'Audio', items: grouped.audio },
    ].filter((section) => section.items.length > 0);

    return sections.map((section) => (
      <Box key={section.key} style={{ marginBottom: 12 }}>
        <Typography className={classes.mediaTypeLabel}>
          {section.label} ({section.items.length})
        </Typography>
        <Box display="flex" flexWrap="wrap" gridGap={12}>
          {section.items.map(({ item: url, index: idx }) =>
            renderReadOnlyMediaTile(url, idx, row.eventName)
          )}
        </Box>
      </Box>
    ));
  };

  const closeMediaPlayer = () => {
    setMediaPlayer({ open: false, url: '', type: 'image', title: '' });
  };

  const renderPendingFileTile = (file, idx, previewUrl) => {
    const mediaType = getMediaTypeFromFile(file);
    const key = fileKey(file);

    const previewBody = () => {
      if (mediaType === 'video') {
        return (
          <Box className={classes.mediaPlayTile} title={file.name}>
            <VideocamIcon style={{ color: '#fff', fontSize: 28 }} />
            <PlayArrowIcon
              style={{
                position: 'absolute',
                color: '#fff',
                fontSize: 22,
                bottom: 8,
                right: 8,
              }}
            />
          </Box>
        );
      }
      if (mediaType === 'audio') {
        return (
          <Box className={classes.mediaAudioTile} title={file.name}>
            <AudiotrackIcon style={{ color: '#1769d6', fontSize: 32 }} />
          </Box>
        );
      }
      return <img src={previewUrl} alt={file.name} className={classes.previewThumb} />;
    };

    return (
      <Box key={key} textAlign="center">
        <Box position="relative" display="inline-block">
          {previewBody()}
          <Button
            size="small"
            className={classes.removeThumbBtn}
            onClick={() => removePendingImageAt(idx)}
            aria-label={`Remove ${file.name}`}
            disabled={uploading}
          >
            ❌
          </Button>
        </Box>
        <Typography className={classes.pendingFileName} title={file.name}>
          {file.name}
        </Typography>
      </Box>
    );
  };

  const renderUploadedMediaTile = (url, idx) => {
    const mediaType = getMediaTypeFromUrl(url);

    const tileBody = () => {
      if (mediaType === 'video') {
        return (
          <Box
            className={classes.mediaPlayTile}
            onClick={() => openMediaPlayer(url, 'video', formik.values.eventName)}
            role="button"
            tabIndex={0}
            aria-label="Play video"
          >
            <PlayArrowIcon style={{ color: '#fff', fontSize: 36 }} />
          </Box>
        );
      }
      if (mediaType === 'audio') {
        return (
          <Box
            className={classes.mediaAudioTile}
            onClick={() => openMediaPlayer(url, 'audio', formik.values.eventName)}
            role="button"
            tabIndex={0}
            aria-label="Play audio"
          >
            <AudiotrackIcon style={{ color: '#1769d6', fontSize: 32 }} />
          </Box>
        );
      }
      return (
        <img
          src={url}
          alt={`Preview ${idx + 1}`}
          className={classes.previewThumb}
          onClick={() => openMediaPlayer(url, 'image', formik.values.eventName)}
          style={{ cursor: 'pointer' }}
        />
      );
    };

    return (
      <Box key={`${url}-${idx}`} position="relative" display="inline-block">
        {tileBody()}
        <Button
          size="small"
          className={classes.removeThumbBtn}
          onClick={() => removeImage(idx, url)}
        >
          ❌
        </Button>
      </Box>
    );
  };

  const renderUploadedMediaSection = () => {
    const urls = Array.isArray(imageslist) ? imageslist.filter(Boolean) : [];
    if (!urls.length) return null;

    const grouped = groupMediaByType(urls, getMediaTypeFromUrl);
    const sections = [
      { key: 'image', label: 'Photos', items: grouped.image },
      { key: 'video', label: 'Videos', items: grouped.video },
      { key: 'audio', label: 'Audio', items: grouped.audio },
    ].filter((section) => section.items.length > 0);

    return sections.map((section) => (
      <Box key={section.key} style={{ width: '100%', marginTop: 12 }}>
        <Typography className={classes.mediaTypeLabel}>
          {section.label} ({section.items.length})
        </Typography>
        <Box display="flex" flexWrap="wrap" gridGap={12}>
          {section.items.map(({ item: url, index: idx }) => renderUploadedMediaTile(url, idx))}
        </Box>
      </Box>
    ));
  };

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Calendar Of Events</Typography>
          <Typography className={classes.pageSubtitle}>
            Create and manage class events, attach photos, videos, and audio, and track them by class and section.
          </Typography>
        </Box>
        <Button
          className={classes.primaryBtn}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpen(true)}
        >
          Add Event
        </Button>
      </Box>

      <Card elevation={0} className={classes.filtersCard} style={{ marginBottom: 16 }}>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gridGap={16}>
          <Box flex={1} minWidth={240}>
            <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '1.05rem' }}>
              School Calendar Document
            </Typography>
            <Typography style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 4 }}>
              Upload school calendars as Word documents (.doc or .docx). You can add multiple files. Parents can download them from their calendar page.
            </Typography>
            {schoolCalenderDocs.length > 0 && (
              <Box mt={1.5} display="flex" flexDirection="column" gridGap={8}>
                {schoolCalenderDocs.map((doc) => (
                  <Box
                    key={doc._id}
                    display="flex"
                    alignItems="center"
                    gridGap={8}
                    p={1.5}
                    style={{
                      borderRadius: 10,
                      backgroundColor: '#eef4ff',
                      border: '1px solid #d6e4ff',
                    }}
                  >
                    <DescriptionIcon style={{ color: '#1769d6' }} />
                    <Box flex={1} minWidth={0}>
                      <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.9rem' }}>
                        {getDocumentFileName(doc.schoolCalenderDocument)}
                      </Typography>
                      <Typography style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: 2 }}>
                        {doc.classId?.className ? `Class: ${doc.classId.className}` : 'All classes'}
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                      onClick={() => window.open(doc.schoolCalenderDocument, '_blank', 'noopener,noreferrer')}
                      style={{ textTransform: 'none', color: '#1769d6' }}
                    >
                      Open
                    </Button>
                    <IconButton
                      size="small"
                      onClick={() => handleSchoolCalenderRemove(doc)}
                      disabled={schoolCalenderUploading}
                    >
                      <DeleteIcon style={{ fontSize: 18, color: '#e53935' }} />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
          <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={10}>
            <Box>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Class (optional)
              </Typography>
              <FormControl variant="outlined" size="small" style={{ minWidth: 180 }}>
                <Select
                  value={schoolCalenderClassId}
                  displayEmpty
                  onChange={(e) => setSchoolCalenderClassId(e.target.value)}
                  disabled={schoolCalenderUploading}
                >
                  <MenuItem value=""><em>All Classes</em></MenuItem>
                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <input
              id="school-calender-upload"
              type="file"
              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: 'none' }}
              disabled={schoolCalenderUploading}
              onChange={handleSchoolCalenderUpload}
            />
            <label htmlFor="school-calender-upload">
              <Button
                component="span"
                variant="contained"
                className={classes.primaryBtn}
                startIcon={
                  schoolCalenderUploading ? (
                    <CircularProgress size={18} style={{ color: '#fff' }} />
                  ) : (
                    <CloudUploadIcon />
                  )
                }
                disabled={schoolCalenderUploading}
              >
                Add Word Document
              </Button>
            </label>
          </Box>
        </Box>
      </Card>

      {noteOpen && (
        <Box className={classes.noteBanner}>
          <Box className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </Box>
          <Box flex={1}>
            <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
              Manage your events
            </Typography>
            <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2 }}>
              Use the view icon to see special notes, video link, icon, and media. Add or update photos with the Media button. Edit or delete from the actions on each row.
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)}>
            <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
          </IconButton>
        </Box>
      )}

      <Card elevation={0} className={classes.filtersCard}>
        <Box className={classes.filtersTopRow}>
          <span className={classes.filtersChip} onClick={() => setFiltersOpen((v) => !v)}>
            <FilterListIcon style={{ fontSize: 18 }} />
            Filters
            {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
            {filtersOpen ? <ExpandMoreIcon style={{ fontSize: 18 }} /> : <ChevronRightIcon style={{ fontSize: 18 }} />}
          </span>
        </Box>

        <Collapse in={filtersOpen}>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Class
              </Typography>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select value={listClassId} displayEmpty onChange={onListClassChange}>
                  <MenuItem value=""><em>All Classes</em></MenuItem>
                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Section
              </Typography>
              <FormControl variant="outlined" size="small" fullWidth disabled={!listClassId}>
                <Select value={listSectionId} displayEmpty onChange={onListSectionChange}>
                  <MenuItem value=""><em>All Sections</em></MenuItem>
                  {listSectionList.map(({ _id, sectionName }) => (
                    <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </Collapse>
      </Card>

      <Card elevation={0} className={classes.tableCard}>
        <Box className={classes.toolbar}>
          <Box display="flex" alignItems="center" gridGap={10}>
            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
              {filteredList.length} Event{filteredList.length !== 1 ? 's' : ''}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={10}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search events..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Tooltip title="Columns">
              <IconButton className={classes.iconBtnOutlined} size="small" onClick={(e) => setColumnMenuAnchor(e.currentTarget)}>
                <ViewColumnIcon style={{ fontSize: 20, color: '#46566b' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Refresh">
              <IconButton className={classes.iconBtnOutlined} size="small" onClick={getCalenderAssignmentList}>
                <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
          <Table stickyHeader className="mb-0 dashboard-table-row-hover" size="small">
            <TableHead>
              <TableRow>
                {columnConfig.filter((c) => visibleCols[c.id]).map((c) => (
                  <TableCell key={c.id} className={classes.headCell}>{c.label}</TableCell>
                ))}
                <TableCell className={classes.headCell} align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={visibleColCount} align="center" style={{ padding: 32, color: '#7a8aa0' }}>
                    No events found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredList.slice(pg * rpg, pg * rpg + rpg).map((calenderassignment) => (
                  <TableRow key={calenderassignment._id} hover>
                    {visibleCols.student && (
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap={8}>
                          <Chip
                            size="small"
                            label={getStudentCountLabel(calenderassignment)}
                            className={classes.studentCountChip}
                          />
                          <Tooltip title="View students">
                            <IconButton
                              className={classes.iconAction}
                              size="small"
                              onClick={() => openViewStudents(calenderassignment)}
                              aria-label="View students"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    )}
                    {visibleCols.eventName && (
                      <TableCell style={{ fontWeight: 600, color: '#0f2d4d' }}>{calenderassignment.eventName}</TableCell>
                    )}
                    {visibleCols.class && (
                      <TableCell>
                        {calenderassignment.classId ? (
                          <Chip size="small" label={calenderassignment.classId.className} className={classes.classChip} />
                        ) : '-'}
                      </TableCell>
                    )}
                    {visibleCols.section && (
                      <TableCell>
                        {calenderassignment.sectionId ? (
                          <Chip size="small" label={calenderassignment.sectionId.sectionName || calenderassignment.sectionId} className={classes.sectionChip} />
                        ) : '-'}
                      </TableCell>
                    )}
                    {visibleCols.details && (
                      <TableCell>
                        <Tooltip title="View details">
                          <IconButton
                            className={classes.iconAction}
                            size="small"
                            onClick={() => openViewEventDetails(calenderassignment)}
                            aria-label="View event details"
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    )}
                    {visibleCols.date && (
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap={6} style={{ color: '#46566b' }}>
                          <EventIcon style={{ fontSize: 16, color: '#9aa6b6' }} />
                          {formatDate(calenderassignment.date)}
                        </Box>
                      </TableCell>
                    )}
                    {visibleCols.images && (
                      <TableCell>
                        <Button
                          size="small"
                          variant="contained"
                          className={classes.imagesBtn}
                          startIcon={<ImageIcon style={{ fontSize: 16 }} />}
                          style={{
                            backgroundColor: eventHasImages(calenderassignment) ? '#0d9488' : '#1769d6',
                            color: '#fff',
                          }}
                          onClick={() =>
                            history.push(`/app/calenderassignment/${calenderassignment._id}/add-images`)
                          }
                        >
                          {eventHasImages(calenderassignment) ? 'Edit Media' : 'Add Media'}
                        </Button>
                      </TableCell>
                    )}
                    <TableCell align="right">
                      <Box className={classes.actionsCell}>
                        <Tooltip title="Edit event">
                          <IconButton
                            className={classes.iconAction}
                            size="small"
                            onClick={() => editCalenderAssignment(calenderassignment)}
                            aria-label="Edit event"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete event">
                          <IconButton
                            size="small"
                            onClick={() => deleteCalenderAssignment(calenderassignment)}
                            aria-label="Delete event"
                            style={{ color: '#e53935', padding: 6 }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[1000, 10000, 1000000]}
          count={filteredList.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor)}
        onClose={() => setColumnMenuAnchor(null)}
      >
        {columnConfig.map((c) => (
          <MenuItem key={c.id} onClick={() => setVisibleCols((prev) => ({ ...prev, [c.id]: !prev[c.id] }))}>
            <Checkbox checked={visibleCols[c.id]} size="small" color="primary" />
            {c.label}
          </MenuItem>
        ))}
      </Menu>

      <Dialog
        open={viewEventDetails.open}
        onClose={closeViewEventDetails}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: classes.eventDetailsDialogPaper }}
      >
        <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d', paddingBottom: 8 }}>
          Event details — {viewEventDetails.row?.eventName || ''}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {viewEventDetails.row && (() => {
            const row = viewEventDetails.row;
            const observationText = String(row.observation || '').trim();
            const videoLink = String(row.video || '').trim();
            const eventIcon = getRowEventIcon(row);

            return (
              <>
                <Box className={classes.eventDetailBlock}>
                  <Typography className={classes.eventDetailLabel}>Special instructions</Typography>
                  <Typography
                    style={{
                      color: '#0f2d4d',
                      fontSize: '0.9rem',
                      lineHeight: 1.65,
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {observationText || '—'}
                  </Typography>
                </Box>

                <Box className={classes.eventDetailBlock}>
                  <Typography className={classes.eventDetailLabel}>Video link</Typography>
                  {videoLink ? (
                    <Typography
                      component="a"
                      href={videoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#1769d6', fontSize: '0.9rem', wordBreak: 'break-all' }}
                    >
                      {videoLink}
                    </Typography>
                  ) : (
                    <Typography variant="body2" color="textSecondary">—</Typography>
                  )}
                </Box>

                <Box className={classes.eventDetailBlock}>
                  <Typography className={classes.eventDetailLabel}>Event icon</Typography>
                  {eventIcon ? (
                    <Box display="flex" alignItems="center" gridGap={10}>
                      {eventIcon.imageUrl && (
                        <img
                          src={eventIcon.imageUrl}
                          alt={eventIcon.iconName || 'Event icon'}
                          style={{ width: 36, height: 36, objectFit: 'contain' }}
                        />
                      )}
                      <Typography style={{ color: '#0f2d4d', fontSize: '0.9rem' }}>
                        {eventIcon.iconName || 'Selected icon'}
                      </Typography>
                    </Box>
                  ) : (
                    <Typography variant="body2" color="textSecondary">—</Typography>
                  )}
                </Box>

                <Box className={classes.eventDetailBlock} style={{ marginBottom: 0 }}>
                  <Typography className={classes.eventDetailLabel}>Uploaded media</Typography>
                  {renderEventDetailsMedia(row)}
                </Box>
              </>
            );
          })()}
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '12px 20px' }}>
          <Button onClick={closeViewEventDetails} style={{ textTransform: 'none' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <Box className={classes.dialogTitleBar}>
          <Typography className={classes.dialogTitleText}>
            {calenderAssignment._id ? 'Edit Event' : 'Add Event'}
          </Typography>
          <IconButton size="small" onClick={handleClose} disabled={addEventLoading}>
            <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
          </IconButton>
        </Box>

        <DialogContent className={classes.dialogBody}>
          <Box className={classes.formSection}>
            <Typography className={classes.sectionLabel}>Class &amp; Students</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={formik.touched.classId && Boolean(formik.errors.classId)}
                >
                  <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="classId"
                    label="Select Class"
                    value={formik.values.classId}
                    onChange={(e) => {
                      formik.setFieldValue('sectionId', '');
                      formik.handleChange(e);
                      getSectionListByClass(e.target.value);
                      getStudentList(e.target.value, undefined);
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                  {formik.touched.classId && formik.errors.classId && (
                    <FormHelperText>{formik.errors.classId}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" size="small" fullWidth disabled={sectionList.length === 0}>
                  <InputLabel id="section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="section-select-label"
                    id="section-select"
                    name="sectionId"
                    label="Select Section"
                    value={formik.values.sectionId || ''}
                    disabled={sectionList.length === 0}
                    onChange={(e) => {
                      formik.handleChange(e);
                      getStudentList(formik.values.classId, e.target.value || undefined);
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {sectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox name="isEventForAllStudent" id="terms"
                      color="primary"
                      value={formik.values.isEventForAllStudent}
                      checked={formik.values.isEventForAllStudent}
                      onChange={formik.handleChange}
                    />
                  }
                  label="For All Class Students"
                />
              </Grid>
              {!formik.values.isEventForAllStudent && (
                <Grid item xs={12}>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel id="studentName-label">Student Name</InputLabel>
                    <Select
                      labelId="studentName-label"
                      id="studentName-select"
                      label="Student Name"
                      name="studentId"
                      multiple
                      value={formik.values.studentId}
                      onChange={formik.handleChange}
                      renderValue={(selected) => {
                        const selectedNames = studentList
                          .filter(({ _id }) => selected.includes(_id))
                          .map(({ studentName }) => studentName);
                        return selectedNames.join(", ");
                      }}
                    >
                      {studentList.map(({ _id, studentName }) => (
                        <MenuItem key={_id} value={_id}>{studentName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20 }}>
            <Typography className={classes.sectionLabel}>Event Details</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="eventName"
                  name="eventName"
                  label="Event"
                  type="text"
                  value={formik.values.eventName}
                  onChange={formik.handleChange}
                  error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                  helperText={formik.touched.eventName && formik.errors.eventName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="icon-select-label">Select Icon (Optional)</InputLabel>
                  <Select
                    labelId="icon-select-label"
                    id="iconId"
                    name="iconId"
                    label="Select Icon (Optional)"
                    value={formik.values.iconId || ''}
                    onChange={formik.handleChange}
                    renderValue={(selected) => {
                      if (!selected) return 'None';
                      const selectedIcon = activeIcons.find(icon => icon._id === selected);
                      if (selectedIcon) {
                        return (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <img
                              src={selectedIcon.imageUrl}
                              alt={selectedIcon.iconName}
                              style={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px' }}
                            />
                            <span>{selectedIcon.iconName}</span>
                          </Box>
                        );
                      }
                      return 'None';
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {activeIcons.map((icon) => (
                      <MenuItem key={icon._id} value={icon._id}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <img
                            src={icon.imageUrl}
                            alt={icon.iconName}
                            style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '4px' }}
                          />
                          <span>{icon.iconName}</span>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="date"
                  name="date"
                  label="Event Date"
                  type="date"
                  value={formik.values.date}
                  onChange={formik.handleChange}
                  error={formik.touched.date && Boolean(formik.errors.date)}
                  helperText={formik.touched.date && formik.errors.date}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="video"
                  name="video"
                  label="Video Link"
                  type="text"
                  value={formik.values.video}
                  onChange={formik.handleChange}
                  error={formik.touched.video && Boolean(formik.errors.video)}
                  helperText={formik.touched.video && formik.errors.video}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="observation"
                  name="observation"
                  label="Special instructions"
                  type="text"
                  multiline
                  minRows={2}
                  value={formik.values.observation}
                  onChange={formik.handleChange}
                  error={formik.touched.observation && Boolean(formik.errors.observation)}
                  helperText={formik.touched.observation && formik.errors.observation}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20, marginBottom: 0 }}>
            <Typography className={classes.sectionLabel}>Photos, videos &amp; audio</Typography>
            <Box className={classes.uploadBox}>
              <input
                type="file"
                accept="image/*,video/*,audio/*,.mp3,.mp4,.wav,.webm,.mov,.m4a,.aac"
                id="calendar-event-upload"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              <ImageIcon style={{ fontSize: 30, color: '#9aa6b6' }} />
              <Typography style={{ color: '#6b7280', fontSize: '0.82rem', margin: '6px 0 12px' }}>
                Select up to {MAX_MEDIA_AT_A_TIME} files at a time (images, MP4 videos, or MP3/audio). Video and audio files must be {MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.
              </Typography>
              <Box display="flex" justifyContent="center" gridGap={10} flexWrap="wrap">
                <label htmlFor="calendar-event-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    size="small"
                    className={classes.cancelBtn}
                    style={{ border: '1px solid #e6eaf0' }}
                    disabled={uploading}
                  >
                    Choose Files
                  </Button>
                </label>
                <Button
                  type="button"
                  size="small"
                  className={classes.uploadBtn}
                  variant="contained"
                  onClick={handleUpload}
                  disabled={uploading || images.length === 0}
                  startIcon={uploading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                  {uploading ? 'Uploading…' : 'Upload'}
                </Button>
              </Box>
              {uploading && (
                <Box mt={2}>
                  <Box display="flex" alignItems="center" justifyContent="center" gridGap={8} mb={1}>
                    <CircularProgress size={22} />
                    <Typography style={{ fontSize: '0.82rem', color: '#46566b' }}>
                      Uploading {uploadProgress.current} of {uploadProgress.total}
                      {uploadProgress.fileName ? ` — ${uploadProgress.fileName}` : ''}
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={
                      uploadProgress.total > 0
                        ? Math.round((uploadProgress.current / uploadProgress.total) * 100)
                        : 0
                    }
                    style={{ height: 8, borderRadius: 4 }}
                  />
                </Box>
              )}
            </Box>

            {pendingPreviews.length > 0 && !uploading && (
              <Box className={classes.pendingPanel}>
                <Typography style={{ fontWeight: 600, fontSize: '0.82rem', color: '#46566b', marginBottom: 10 }}>
                  {pendingPreviews.length} file{pendingPreviews.length === 1 ? '' : 's'} selected — click Upload to attach
                </Typography>
                {(() => {
                  const grouped = groupMediaByType(images, getMediaTypeFromFile);
                  const sections = [
                    { key: 'image', label: 'Photos', items: grouped.image },
                    { key: 'video', label: 'Videos', items: grouped.video },
                    { key: 'audio', label: 'Audio', items: grouped.audio },
                  ].filter((section) => section.items.length > 0);
                  return sections.map((section) => (
                    <Box key={section.key}>
                      <Typography className={classes.mediaTypeLabel}>
                        {section.label} ({section.items.length})
                      </Typography>
                      <Box display="flex" flexWrap="wrap" gridGap={12}>
                        {section.items.map(({ item: file, index: idx }) => {
                          const preview = pendingPreviews.find((p) => p.key === fileKey(file));
                          return renderPendingFileTile(file, idx, preview?.url);
                        })}
                      </Box>
                    </Box>
                  ));
                })()}
              </Box>
            )}

            {renderUploadedMediaSection()}
          </Box>
        </DialogContent>

        <DialogActions className={classes.dialogFooter}>
          <Button onClick={handleClose} disabled={addEventLoading} className={classes.cancelBtn}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            className={classes.addBtn}
            onClick={formik.handleSubmit}
            disabled={addEventLoading}
            startIcon={addEventLoading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {addEventLoading ? "Adding…" : (calenderAssignment._id ? "Update" : "Add")}
          </Button>
        </DialogActions>

      </Dialog>

      <Dialog
        open={mediaPlayer.open}
        onClose={closeMediaPlayer}
        maxWidth="md"
        fullWidth
        PaperProps={{ className: classes.mediaPlayerDialog }}
      >
        <DialogTitle style={{ color: '#fff', backgroundColor: '#0f2d4d' }}>
          {mediaPlayer.title || (mediaPlayer.type === 'video' ? 'Video' : mediaPlayer.type === 'audio' ? 'Audio' : 'Image')}
          <IconButton
            onClick={closeMediaPlayer}
            style={{ position: 'absolute', right: 8, top: 8, color: '#fff' }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 0, backgroundColor: '#000', textAlign: 'center' }}>
          {mediaPlayer.type === 'video' && (
            <video
              key={mediaPlayer.url}
              src={mediaPlayer.url}
              controls
              autoPlay
              className={classes.mediaPlayerVideo}
            />
          )}
          {mediaPlayer.type === 'audio' && (
            <Box p={3}>
              <AudiotrackIcon style={{ color: '#1769d6', fontSize: 48, marginBottom: 16 }} />
              <audio key={mediaPlayer.url} src={mediaPlayer.url} controls autoPlay style={{ width: '100%' }} />
            </Box>
          )}
          {mediaPlayer.type === 'image' && (
            <img
              src={mediaPlayer.url}
              alt={mediaPlayer.title || 'Preview'}
              style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={viewStudents.open}
        onClose={closeViewStudents}
        maxWidth={false}
        PaperProps={{ className: classes.studentsDialogPaper }}
      >
        <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d' }}>
          Students — {viewStudents.title}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {viewStudents.isAll && (
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
              All students in {viewStudents.items.length ? 'this class/section' : 'class/section'}
            </Typography>
          )}
          {viewStudents.loading ? (
            <Box display="flex" justifyContent="center" py={3}>
              <CircularProgress size={28} />
            </Box>
          ) : viewStudents.items.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              No students found for this event.
            </Typography>
          ) : (
            <>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 700, color: '#1769d6', marginBottom: 12 }}
              >
                {viewStudents.items.length} student{viewStudents.items.length !== 1 ? 's' : ''}
              </Typography>
              <List dense className={classes.studentsList}>
                {viewStudents.items.map((student, index) => (
                  <ListItem key={student._id || index} divider={index < viewStudents.items.length - 1}>
                    <ListItemText primary={`${index + 1}. ${student.name}`} />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '12px 20px' }}>
          <Button onClick={closeViewStudents} style={{ textTransform: 'none' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

